<template lang="html">
  <div>
    <ul
      v-if="!this.$store.state.userIsActivatingCreatedPage"
      class="nav nav-pills col-12 mb-2 p-0 mt-4"
    >
      <li
        class="nav-item btn-square col-6 m-0 p-0"
        @click="loginTabSelected"         
      >
        <a
          class="nav-link text-center"
          :class="{ active: selectedPage === 'login' }"
        >
          Login
        </a>
      </li>
      <li
        class="nav-item btn-square col-6 m-0 p-0"
        @click="registerTabSelected"
      >
        <a
          class="nav-link text-center"
          :class="{ active: selectedPage === 'register' }"
        >
          Register
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "LoginTabs",

  props: {
    selectedPage: {
      type: String,
      default: ""
    }
  },

  methods: {
    loginTabSelected: function() {
      this.$parent.$emit("StatusCheckLogin", "login");
    },

    registerTabSelected: function() {
      this.$parent.$emit("StatusCheckLogin", "");
    }
  }
};
</script>

<style scoped>
a.nav-link {
  color: #999;
  cursor: pointer;
}

.nav-pills .nav-link {
  border-radius: 0;
}

.nav-pills .nav-link.active {
  background-color: #fff;
  color: #f57c33;
}

.nav-item {
  background: #e8e8e8;
  color: #999;
}
</style>
